import * as THREE from 'three';

export class ConstructedProfile {
    articleName: string;
    system: string;
    type: string;
    depth: string;
    width: string;
    outsideWidth: string;
    insideWidth: string;
    profileShapes: ProfileShape[];

    constructor(obj: {
        name?: string,
        system?: string
        type?: string,
        depth?: string,
        width?: string,
        inW?: string,
        outW?: string,
        shapes?: ProfileShape[]
    }) {
        this.articleName = obj.name ?? "";
        this.system = obj.system ?? "";
        this.type = obj.type ?? "";
        this.depth = obj.depth ?? "";
        this.width = obj.width ?? "";
        this.insideWidth = obj.inW ?? "";
        this.outsideWidth = obj.outW ?? "";
        (obj.shapes ?? []).forEach((shape) => {

        })
        this.profileShapes = obj.shapes ?? [];
    }

    static createObj(obj: {
        name?: string,
        system?: string,
        type?: string,
        depth?: string,
        width?: string,
        inW?: string,
        outW?: string,
        shapes?: ProfileShape[]
    }) {
        return new ConstructedProfile(obj);
    }
}

export class ProfileShape {
    shape: THREE.Shape;
    useMaterial: string;

    private constructor(shape: THREE.Shape, useMat?: string) {
        this.shape = shape;
        this.useMaterial = useMat ?? "";
    }

    static createObj(shape: THREE.Shape, useMat?: string) {
        return new ProfileShape(shape, useMat);
    }
}
